module.exports = __webpack_public_path__ + "img/pan1.18059c70.jpg";